// Dependencies
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

// Channels
var channel = Radio.channel('global');

var GetRegions = Marionette.Object.extend({
    initialize: function(options) {
        channel.reply('get:regions', function() {
            return options.regions;
        });
    },
    destroy: function() {
        channel.stopReplying('get:regions');
    },
});

module.exports = GetRegions;
